<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 11:56:44
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:53:35
 * @name: 品牌表格
 * @Description: 品牌表格
 * @FilePath: \preSaleNafterSaleBackstage\src\components\modelGoodsManage\table-brand.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <layout v-show="step === 1" :step="step">
      <template v-slot:head>
        <el-button size="mini" plain @click="brandAdd">添加品牌</el-button>
      </template>
      <template v-slot:table>
        <el-table
          :data="modelGoods.table_brand_data.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="id" label="ID">
          </el-table-column>
          <el-table-column align="center" prop="level_name" label="级别">
          </el-table-column>
          <el-table-column align="center" prop="category_name" label="名称">
          </el-table-column>
          <el-table-column align="center" label="查看系列">
            <template slot-scope="scope">
              <el-button type="text" @click="brandNext(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="statistics_count"
            label="系列数量"
          >
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                :value="scope.row.status"
                @change="brandStatusChange($event, scope.row.id)"
                active-color="#13ce66"
                :inactive-color="$scssVars['Vars-font-placeholder-color']"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="brandEdit(scope.row)"
                >编辑</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="brandDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="Number(modelGoods.table_brand_data.total)"
        ></Pagination>
      </template>
    </layout>
    <addNeditBrand
      ref="addNeditBrand"
      @edit="brandEditHandler"
      @add="brandAddHandler"
    ></addNeditBrand>
  </div>
</template>
<script>
import layout from "./layout.vue";
import addNeditBrand from "./dialog/addNedit-brand.vue";
import { confirmation, debounceation } from "@/utils/decorator";

export default {
  name: "modelGoodsManage-tableBrand",
  components: {
    layout,
    addNeditBrand,
  },
  props: {
    step: {
      type: Number,
    },
    modelGoods: {
      type: Object,
    },
  },
  data() {
    // methods -> initData内初始化
    return {
      loading: false, //表格加载状态
      pagination: {}, //品牌表格分页信息
    };
  },
  watch: {
    // 分页器数据变化,更新表格
    pagination: {
      handler(nv, ov) {
        ov.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新组件
     */
    refresh() {
      this.initData();
      this.getTableData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.modelGoods.table_series_data.total = 0;
      this.modelGoods.table_series_data.list = [];
      this.pagination = {
        //品牌表格分页信息
        page: 1, //当前页码
        limit: 10, //每页数据量
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取品牌表格数据
     */
    getTableData() {
      this.loading = true;
      let params = this.pagination;
      this.modelGoods.getTableBrandData(params).finally(() => {
        this.loading = false;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 变化品牌表格中品牌的状态
     * @param {Boolean} e 变化值
     * @param {Number | String} id 品牌id
     */
    @debounceation(300)
    brandStatusChange(e, id) {
      this.modelGoods.brandStatusChange({
        category_id: id,
        status: e,
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看系列
     * @param {Object} row 品牌表格行数据
     */
    @debounceation(300)
    brandNext(row) {
      this.$emit("update:step", 2);
      this.modelGoods.table_series_data.id = row.id;
      this.modelGoods.table_series_data.category_name = row.category_name;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加品牌
     */
    @debounceation(300)
    brandAdd() {
      this.$refs.addNeditBrand.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加品牌弹窗回传
     * @param {Object} form 回传数据
     */
    brandAddHandler(form) {
      let params = form;
      params.parent_id = "";
      this.modelGoods.addBrand(params).then((res) => {
        this.getTableData();
        this.$refs.addNeditBrand.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑品牌
     * @param {Object} row 品牌表格行数据
     */
    @debounceation(300)
    brandEdit(row) {
      this.$refs.addNeditBrand.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑品牌弹窗回传
     * @param {Object} form 回传数据
     */
    brandEditHandler(form) {
      this.modelGoods.editBrand(form).then((res) => {
        this.getTableData();
        this.$refs.addNeditBrand.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除品牌
     * @param {Object} row 品牌表格行数据
     */
    @confirmation((row) => `确认删除品牌名为${row.category_name}的品牌?`)
    brandDel(row) {
      this.modelGoods.delBrand({ category_id: row.id }).then((res) => {
        this.getTableData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table {
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-switch__core:before {
    content: "隐";
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 21px;
  }
  /deep/.is-checked .el-switch__core:before {
    content: "显" !important;
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 5px;
  }
}
</style>